export default __webpack_public_path__ + "static/media/wholetextfinal.d4f0959e.png";